<template>
  <div class='row global-data'>
    <div class='col-12 title'>
      {{ $t('results.globalDataResults') }}
    </div>
    <div class='col-12 pt-1 respondets'>
      {{ $t('results.respondets', { number: total }) }}
    </div>
    <div class='col-12 pt-2 pl-0 pr-0 chart'>
      <div class='global-data-chart' ref='globaldatachart'></div>
    </div>
  </div>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_material from '@amcharts/amcharts4/themes/material'

if (process.env.NODE_ENV === 'production') {
  am4core.options.commercialLicense = true
}

am4core.options.onlyShowOnViewport = true

am4core.useTheme(am4themes_material)

export default {
  data () {
    return {
      chart: null,
      total: 0
    }
  },
  computed: {
    participantsByGender () {
      return this.$store.getters.getParticipantsByGender
    }
  },
  methods: {
    loadChart () {
      this.chart = am4core.create(this.$refs.globaldatachart, am4charts.XYChart)

      this.chart.hiddenState.properties.opacity = 0
      this.chart.numberFormatter.numberFormat = '#.'

      this.chart.data = this.participantsByGender

      let categoryAxis = this.chart.yAxes.push(new am4charts.CategoryAxis())
      categoryAxis.dataFields.category = 'gender'
      categoryAxis.renderer.inversed = true
      categoryAxis.renderer.grid.template.location = 0
      categoryAxis.renderer.minGridDistance = 40

      let label = categoryAxis.renderer.labels.template
      label.wrap = true
      label.maxWidth = 80
      label.fontSize = '.9rem'

      let valueAxis = this.chart.xAxes.push(new am4charts.ValueAxis())
      valueAxis.renderer.minGridDistance = 50
      valueAxis.fontSize = 10
      valueAxis.title.text = this.$t('results.noOfRespondents')
      valueAxis.title.fontSize = 12
      valueAxis.extraMax = 0.5

      let series = this.chart.series.push(new am4charts.ColumnSeries())
      series.dataFields.categoryY = 'gender'
      series.dataFields.valueX = 'participants'
      series.name = 'participants'
      series.columns.template.width = am4core.percent(10)
      series.stroke = am4core.color('#2bb1c4')
      series.fill = am4core.color('#2bb1c4')
      series.columns.template.height = am4core.percent(30)
      series.calculatePercent = true

      var valueLabel = series.bullets.push(new am4charts.LabelBullet())
      valueLabel.label.text = '{valueX.percent}%'
      valueLabel.label.truncate = false
      valueLabel.label.fontSize = 12
      valueLabel.label.horizontalCenter = 'left'
      valueLabel.label.dx = 10
    }
  },
  mounted () {
    this.loadChart()
  },
  watch: {
    participantsByGender (participants) {
      for (let i = 0; i < participants.length; i++) {
        this.total += participants[i].participants
      }
      this.loadChart()
      this.chart.invalidateRawData()
    }
  }
}
</script>

<style>
.global-data .title {
  font-weight: 700;
  font-size: 1.2rem !important;
}

.global-data .respondets {
  font-size: 1rem;
  font-weight: 200;
  color: #c1c1c1;
}

.global-data .chart, .global-data-chart {
  height: 30vh;
}
</style>
